//Dependencies
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'react-bootstrap'
//Components
import { SpaLayout } from './SpaLayout'
import ReservationHeader from '../Reservation/ReservationHeader'
import ReservationTimeSlots from '../Reservation/ReservationTimeSlots'
//Actions
import {
    getReservationDates,
    showConflictMsg,
    selectReserveDate,
    addServiceToCart,
    clearReservationDates
} from '../../actions/reservation.actions'
import { selectGuest, setServicesDataFromId } from '../../actions/spaServices.actions'
import { breadCrumbItems } from '../../utils/spaConstants'
//Assets
import '../../css/services.css'

class SpaReserve extends Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.myRef = null
       
    }
    serviceDetailsRef=(ref)=>this.myRef = ref

    componentDidMount() {

        window.scrollTo(0, 0)
        // eslint-disable-next-line no-undef
        this.props.actions.showConflictMsg('')
        //Page Title
        if (!this.props.match.params.spaId) {
            let { selectedService } = this.props.services;
            document.title = `Reserve ${selectedService.productName}`;
        }
    }
    componentWillUnmount() {
        this.props.actions.clearReservationDates();
    }
    render() {
        let { selectedService = {}, cpNavdata, authDetails = {} } = this.props.services
        let { cart, conflictMsg } = this.props.reservations
        let { appTrigger = 'CP' } = authDetails;
        cpNavdata = (appTrigger === 'POLAR') ? 'none' : cpNavdata;
        let imageUrl = `${process.env.imageUrl}${selectedService.treatmentId}.jpg`

        return (
            <div>
                <main id="container">
                    <div className="spa-content white-bg-tint  spa-font-family cp-border-radius">
                        <Container
                            fluid={true}
                            style={{ padding: '0' }}
                            className="reservation-container services-container"
                        >
                            <SpaLayout
                                cpNavdata={cpNavdata}
                                cart={cart}
                                isReserve={true}
                                items={breadCrumbItems.reservations}
                                appTrigger={appTrigger}
                            >
                                <article className="  cp-spacing">
                                    <header className="reservation-header">
                                        <ReservationHeader
                                            serviceref={this.myRef}
                                            selectedService={selectedService}
                                        />
                                    </header>
                                    <div className="article-container container top-spacing-20 bottom-spacing-15 white-bg col-xs-pad-15-bottom">
                                        <section className="select-guest-content ">
                                            <ReservationTimeSlots
                                                serviceref={this.myRef}
                                                conflictMsg={conflictMsg}
                                                reservations={this.props.reservations}
                                                services={this.props.services}
                                                selectedService={selectedService}
                                                actions={this.props.actions}
                                            />
                                        </section>
                                        <section className="service-details full-width">
                                            <div id='service-section-header' class="headline-bar container pb-0">
                                                <h2 className="headline-gray-e6-bg font-size-p11 spa-headline-backgroundblue text-center">
                                                    Service Details
                                                </h2>
                                            </div>
                                            <div
                                                className="services-details-container"
                                                ref={this.serviceDetailsRef}


                                            >
                                                <Row>
                                                    <Col md={4} ls={4}>
                                                        <div className="images">
                                                            <img
                                                                alt=""
                                                                style={{ width: '100%' }}
                                                                src={imageUrl}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col style={{ marginTop: '33px' }} md={8} ls={8}>
                                                        <p className="services-details-text text-mob-left"></p>

                                                        <p className="text-mob-left"> {selectedService.shortDescription}</p>
                                                        <div>
                                                            <h3 className="font-size-p5 gotham-xn-medium text-mob-left">
                                                                Service Promise:{' '}
                                                            </h3>
                                                            <p className="text-mob-left">
                                                                We pride ourselves on enriching the
                                                                lives of all guests with premium
                                                                treatements that nurture wellness on
                                                                every level.If our staff doesnot
                                                                meet your service expectations
                                                                during your treatment, we will issue
                                                                a full refund.
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <h3
                                                                className="font-size-p5 gotham-xn-medium text-mob-left"
                                                                id='cancellation-heading'
                                                                data-test-id="cancellation-heading"
                                                            >
                                                                Cancellation Policy:{' '}
                                                            </h3>
                                                            <p data-test-id="cancellation-contents" className="text-mob-left">
                                                                Please give us 24 hours notice
                                                                before any cancellation to avoid a
                                                                50% service charge.
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <h3
                                                                className="font-size-p5 gotham-xn-medium text-mob-left"
                                                                data-test-id="gratuities-text"
                                                            >
                                                                Spa service charge:{' '}
                                                            </h3>
                                                            <p data-test-id="gratuities-contents" className="text-mob-left">
                                                                A service fee of 18% will be automatically charged at the time of service.
                                                            </p>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </section>
                                    </div>
                                </article>
                            </SpaLayout>
                        </Container>
                    </div>
                </main>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        services: state.services,
        reservations: state.reservations,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            getReservationDates: () => dispatch(getReservationDates()),
            selectReserveDate: (date) => dispatch(selectReserveDate(date)),
            addServiceToCart: (service, inCartClass) =>
                dispatch(addServiceToCart(service, inCartClass)),
            selectGuest: (selectedGuest) => dispatch(selectGuest(selectedGuest)),
            showConflictMsg: (msg) => dispatch(showConflictMsg(msg)),
            clearReservationDates: () => dispatch(clearReservationDates()),
            setServicesDataFromId: (spaId) => dispatch(setServicesDataFromId(spaId))
        },
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpaReserve)
